import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchInput from "../../Components/SearchInput";
import Button from "../../Components/Button/Button";
import ParentTable from "./ParentTable";
import OrganizerTable from "./OrganizerTable";
import { serviceConsumer } from "../../network/ServiceConsumer";
import Loader from "../../Components/Loader/Loader";
import SingleLineTitle from "../../Components/TitleElements/SingleLineTitle";

// Big enough to pull the whole list in one request when "Show All" is used.
const LOAD_ALL = 100000;

const ManageUsers = () => {
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState("Parent")
  const [orgData, setOrgData] = useState()
  const [parentData, setParentData] = useState()
  const [searchInput, setSearchInput] = useState("")
  const [hasFetched, setHasFetched] = useState(false)
  const [lastQuery, setLastQuery] = useState("")
  const levels = ["Parent", "Organizer"];

  const navigate = useNavigate()

  const parentWithData = user === "Parent" && parentData?.list?.length > 0
  const orgWithData = user === "Organizer" && orgData?.list?.length > 0
  const currentData = user === "Organizer" ? orgData : parentData

  // Nothing loads on arrival — the admin searches, or asks for everyone.
  const getUsers = async (searchVal = lastQuery) => {
    setLoading(true)
    try {
      const url = `${process.env.REACT_APP_BASE_URL}/api/admin/list-users`;
      const payload = {
        useType: user === "Organizer" ? "organizer" : "user",
        page: 1,
        limit: LOAD_ALL,
        searchKey: searchVal
      }
      const response = await serviceConsumer("POST", url, payload)
      user === "Organizer" ? setOrgData(response.date) : setParentData(response.date)
      setHasFetched(true)
      setLastQuery(searchVal)
    } catch (error) { }
    setLoading(false)
  }

  // When the user type changes, re-run the current view for the new type.
  useEffect(() => {
    if (hasFetched) getUsers(lastQuery)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  const submitSearch = (e) => {
    if (e) e.preventDefault();
    if (!searchInput.trim()) return;
    getUsers(searchInput.trim());
  }

  const showAll = () => {
    setSearchInput("");
    getUsers("");
  }

  const backToDashboardHandler = () => {
    localStorage.setItem("eventsTab", false)
    navigate("/")
  }

  return (
    <>
      <SingleLineTitle titleName="Users" onBackClick={backToDashboardHandler} />
      <div className="db-body">
        {loading && <Loader />}
        <form onSubmit={submitSearch} className="d-flex flex-column flex-md-row align-items-md-center pt-3" style={{ gap: "10px" }}>
          <div className="col-sm-8 col-md-4">
            <SearchInput searchInput={searchInput} setSearchInput={setSearchInput} />
          </div>
          <Button type="submit" className={searchInput.trim() ? "filled" : "disabled"}>Search</Button>
          <Button type="button" className="outlined" onClick={showAll}>Show All</Button>
          <div className="col-sm-8 col-md-2">
            <select name="typeOfUser" className="dashboard-select" value={user} onChange={(e) => setUser(e.target.value)}>
              {levels?.map((levelOption) => (
                <option key={levelOption} value={levelOption}>{levelOption}</option>
              ))}
            </select>
          </div>
          {hasFetched && <div className="competitor-count">{currentData?.resultCount || 0}</div>}
        </form>

        {!hasFetched && !loading && (
          <div className="d-flex justify-content-center my-5 text-center" style={{ color: "#797979" }}>
            Search for a {user.toLowerCase()} by name or email — or use “Show All” to load everyone.
          </div>
        )}

        {parentWithData && <ParentTable userData={parentData} getUsers={getUsers} serializeHelper={0} />}
        {orgWithData && user === "Organizer" && <OrganizerTable userData={orgData} getUsers={getUsers} serializeHelper={0} />}
        {!loading && hasFetched && currentData?.list?.length === 0 && (
          <div className="d-flex justify-content-center my-5">
            {lastQuery ? `No ${user.toLowerCase()}s match “${lastQuery}”.` : `No ${user.toLowerCase()}s found`}
          </div>
        )}
      </div>
    </>
  );
};

export default ManageUsers;
